import React, { Component } from "react";
import { connect } from "react-redux";
import { createPortal } from "react-dom";
import { Row, Wrapper, Scroll } from "app/NativeComponents/common";
import {
  PopoverMenu,
  SearchBar,
  List,
  InlineButton,
  SelectItem,
  Tag,
  ConfirmLabel,
  SpinWrapper,
  BottomNavBar
} from "app/NativeComponents/snippets";
import {
  updateLead,
  getLists,
  toTitleCase,
  addListToListTabs,
  setActiveListTab,
  pushSidePanel,
  renderDate
} from "app/NativeActions";
class OpenListsButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      showSortDropdown: false,
      sort_by: "date_created_desc",
      show: false
    };
    this.sortButtonRef = React.createRef();
    this.sortDropdownRef = React.createRef();
    this._scroll_view = React.createRef();
  }
  componentDidMount() {
    this.getData({ load_type: "refresh" });
    this.setState({
      showSortDropdown: false
    });
    document.addEventListener("mousedown", this.handleClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }
  componentDidUpdate(prevProps, prevState) {
    const { property, lists, lists_loading } = this.props;

    if (this.state.sort_by !== prevState.sort_by) {
      this.getData({ load_type: "refresh" });

    }
  }

  filterOptions(options) {
    let filtered_options = [];
    const { search } = this.state;
    for (let i = 0; i < options.length; i++) {
      if (
        options[i].label?.toLowerCase().indexOf(search?.toLowerCase()) != -1
      ) {
        filtered_options.push(options[i]);
      }
    }

    return filtered_options;
  }

  getData({ load_type = "load" }) {
    const { token, lists_loading, lists_refreshing, lists_begin, lists } =
      this.props;

    if (!lists_loading && !lists_refreshing) {
      this.props.getLists({
        token: this.props.token,
        load_type: "refresh",
        type: "all_lists",
        search: this.state.search,
        sort_by: this.state.sort_by,
        no_count: true,
        begin: 0,
        onError: () => { },
        onSuccess: () => { }
      });
    }
  }

  onSortButtonClick = () => {
    const button = this.sortButtonRef.current;
    if (!button) return;
    if (this.state.showSortDropdown) {
      this.setState({ showSortDropdown: false });
    } else {
      const rect = button.getBoundingClientRect();
      this.setState({
        showSortDropdown: true,
        dropdownTop: rect.bottom + window.scrollY,
        dropdownLeft: rect.left + window.scrollX
      });
    }
  };

  handleClickOutside = (event) => {
    const dropdown = this.sortDropdownRef.current;
    const button = this.sortButtonRef?.current;

    if (
      (dropdown && dropdown.contains(event.target)) ||
      (button && button.contains(event.target))
    ) {
      return;
    }

    this.setState({ showSortDropdown: false });
  };


  render() {
    const {
      colors,
      isMobile,
      device,
      lists,
      lists_loading,
      style,
      property,
      popoverPlacement = "bottom",
      renderComponent = () => { },
      renderComponentLoading = () => { },
      componentStyle = {},
      list_tabs,
      active_list_tab
    } = this.props;
    const { search, show, sort_by } = this.state;

    return (
      <PopoverMenu
        show={show}
        no_swipe={true}
        no_cancel={true}
        onShow={s => {
          this.setState({
            show: s
          });
        }}
        popover_width={400}
        popover_height={450}
        popoverSheetTop={"75%"}
        popoverPlacement={popoverPlacement}
        popover_title={"My Lists"}
        includeCloseButton={true}
        renderComponent={options => {
          return (
            <Wrapper
              wrapper_ref={this._popover}
              style={{ flex: 1 }}
            >
              {renderComponent({ ...options, pressedIn: show })}
            </Wrapper>
          );
        }}
        renderMenu={() => {
          return (
            <>
              {lists_loading ? (
                <SpinWrapper text="Loading Lists..." />
              ) : (
                <>
                  <Wrapper style={{ padding: "10px", width: "100%" }}>
                    <Row>
                      <SearchBar
                        value={search}
                        style={{
                          margin: 10,
                          marginRight: 0,
                          borderWidth: 0,
                          borderBottomWidth: 0,
                          width: 200
                        }}
                        title="Search Lists"
                        onChange={value => {
                          this.setState({
                            search: value
                          });
                        }}
                      />

                      <div style={{ position: "absolute", right: "10px" }}>
                        <div ref={this.sortButtonRef} style={{ display: "inline-block" }}>
                          <InlineButton
                            onPress={this.onSortButtonClick}
                            pressedIn={this.state.showSortDropdown}
                          >
                            Sort
                          </InlineButton>
                        </div>
                        {this.state.showSortDropdown &&
                          createPortal(
                            <div
                              ref={this.sortDropdownRef}
                              style={{
                                position: "absolute",
                                top: this.state.dropdownTop,
                                left: this.state.dropdownLeft,
                                width: 300,
                                backgroundColor: colors.card_color,
                                padding: 10,
                                borderRadius: 6,
                                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                                zIndex: 9999,
                                height: 300,
                                overflowY: "auto"
                              }}
                            >
                              {[
                                { key: "name_asc", label: "Title (A-Z)" },
                                { key: "name_desc", label: "Title (Z-A)" },
                                { key: "date_created_desc", label: "Date Created (Newest First)" },
                                { key: "date_created_asc", label: "Date Created (Oldest First)" },
                                { key: "lead_count_desc", label: "Leads (Most to Least)" },
                                { key: "lead_count_asc", label: "Leads (Least to Most)" },
                                { key: "last_updated_desc", label: "Last Updated (Newest First)" },
                                { key: "last_updated_asc", label: "Last Updated (Oldest First)" }
                              ].map(option => (
                                <SelectItem
                                  key={option.key}
                                  select_type="radio"
                                  selected={this.state.sort_by === option.key}
                                  onPress={() =>
                                    this.setState({
                                      sort_by: option.key,
                                      showSortDropdown: false
                                    })
                                  }
                                >
                                  {option.label}
                                </SelectItem>
                              ))}
                            </div>,
                            document.body
                          )}
                      </div>
                    </Row>
                  </Wrapper>


                  <List
                    style={{ alignSelf: "stretch" }}
                    items={this.filterOptions(lists)}
                    listFooter={() => {
                      let label_title = "In Trash";
                      if (
                        label_title
                          .toLowerCase()
                          .indexOf(search?.toLowerCase()) != -1
                      ) {
                        return (
                          <SelectItem
                            select_type={"none"}
                            selected={active_list_tab == "in_trash_leads"}
                            onPress={() => {
                              this.props.addListToListTabs("in_trash_leads");
                              this.setState({
                                show: false
                              });
                            }}
                          >
                            {label_title}
                          </SelectItem>
                        );
                      }
                      return null;
                    }}
                    itemStructure={({ item, index }) => {
                      let in_selected_options = false;
                      for (let i = 0; i < list_tabs.length; i++) {
                        if (item.id == list_tabs[i]?.id) {
                          in_selected_options = true;
                        }
                      }

                      return (
                        <SelectItem
                          key={"option_" + index}
                          select_type={
                            item.pinned ? "icon" : "none"
                          }
                          select_icon={
                            item.pinned ? "push-pin" : ""
                          }
                          hover_icon={"launch"}
                          hover_icon_color={colors.orange_color}
                          subtext={renderDate(sort_by.includes("last_updated") ? item.date_updated : item.date_created) + " (" + (sort_by.includes("last_updated") ? "updated" : "created") + ")"}
                          icon_color={colors.light_text_color}
                          selected={active_list_tab?.id == item.id}
                          onPress={() => {
                            this.props.addListToListTabs(item);

                            this.setState({
                              show: false
                            });
                          }}
                        >
                          {item.label}
                        </SelectItem>
                      );
                    }}
                  />
                  <BottomNavBar
                    style={{ backgroundColor: colors.popover_color }}
                  >
                    <InlineButton
                      primary={false}
                      button_type={"full"}
                      onPress={() => {
                        this.props.pushSidePanel({
                          slug: "list_library",
                          overlay: true
                        });
                        this.setState({
                          show: false
                        });
                      }}
                    >
                      Open List Library
                    </InlineButton>
                  </BottomNavBar>
                </>
              )}
            </>
          );
        }}
        menu_items={null}
      />
    );
  }
}
const mapStateToProps = ({ auth, native, settings, list }) => {
  const { token, user } = auth;
  const { isMobile, device } = native;
  const { colors, dark_mode } = settings;
  const { lists, lists_loading, list_tabs, active_list_tab } = list;
  return {
    token,
    user,
    isMobile,
    device,
    colors,
    dark_mode,
    lists,
    lists_loading,
    list_tabs,
    active_list_tab
  };
};

export default connect(mapStateToProps, {
  updateLead,
  getLists,
  addListToListTabs,
  setActiveListTab,
  pushSidePanel
})(OpenListsButton);
